import $ from 'jquery';

/*
 * jQuery Observer pattern
 * inspired by @addyosmani 's code
 * see: http://addyosmani.com/resources/essentialjsdesignpatterns/book/#highlighter_506612
 */
let topic;
const topics = [];

function getTopic(id) {
    let callbacks;
    topic = id && topics[id];
    if (!topic) {
        callbacks = $.Callbacks();
        topic = {
            publish: callbacks.fire,
            subscribe: callbacks.add,
            unsubscribe: callbacks.remove
        };
        if (id) topics[id] = topic;
    }
    return topic;
}

$.observer = {
    publish(id) {
        const args = (2 <= arguments.length) ? Array.prototype.slice.call(arguments, 1) : [];
        const t = getTopic(id);
        return t.publish.apply(t, args);
    },
    publishAsync(id) {
        const args = (2 <= arguments.length) ? Array.prototype.slice.call(arguments, 1) : [];
        const t = getTopic(id);
        return window.setTimeout(() => {
            t.publish.apply(t, args);
        }, 0);
    },
    subscribe(id, fn) {
        return getTopic(id).subscribe(fn);
    },
    unsubscribe(id, fn) {
        return getTopic(id).unsubscribe(fn);
    }
};